import { _, ref, watch, storage, App } from '@zto/zpage'

// 10秒钟内只能请求一次
const OrgRequestDuration = 20000

let __lastRequestTime: number | null = null

let __orgs = ref<any[]>([])
let __orgsLevel1 = ref<any[]>([])
let __orgsLevel2 = ref<any[]>([])

let __flatten_orgs_map: Record<string, string> = {}

export const orgSeparator = '---'

export function getOrgsRef(level = -1) {
  switch (level) {
    case 1:
      return __orgsLevel1
    case 2:
      return __orgsLevel2
    default:
      return __orgs
  }
}

watch(
  () => __orgs.value,
  () => {
    const a1: any[] = []
    const a2: any[] = []

    ;(__orgs.value || []).forEach(p => {
      const _p1 = _.omit(p, 'children')
      a1.push({ ..._p1 })

      const _p2 = { ..._p1, children: [] }
      ;(p.children || []).forEach((c: any) => {
        const _c1 = _.omit(c, 'children')
        _p2.children.push(_c1)
      })

      a2.push(_p2)
    })

    __orgsLevel1.value = a1 || []
    __orgsLevel2.value = a2 || []
  }
)

/** 获取区域列表 */
let __loading = false
export async function loadOrgs(app: App) {
  const appApi = app.api

  if (__orgs.value?.length || !appApi?.getDeptTrees) return __orgs

  if (__loading) return __orgs

  try {
    __loading = true

    // 防止报错
    let data = storage.page.get('orgs') || []

    if (!data?.length) {
      // 防止过去频繁请求接口，导致应用卡死卡死
      if (!__lastRequestTime || new Date().getTime() - __lastRequestTime > OrgRequestDuration) {
        __lastRequestTime = new Date().getTime()

        const _data = await appApi!.getDeptTrees()
        data = [_data]
        storage.page.set('orgs', data)
      }
    }

    __orgs.value = normalizeOrgs(data)
    __loading = false
  } catch (ex) {
    __loading = false
    console.error(ex)
  }

  return __orgs
}

// 解析区域值
export function getOrgData(val: string) {
  if (!val) return []
  return __flatten_orgs_map[val]
}

// 格式化区域
function normalizeOrgs(data: any, level = 0): any[] {
  if (!data || !Array.isArray(data)) return []

  data.forEach(it => {
    if (!it) return
    it.label = it.name
    it.value = String(it.code)
    it.level = level
    __flatten_orgs_map[it.value] = _.omit(it, ['children'])

    normalizeOrgs(it.children, level + 1)
  })

  return data
}
